<template>
  <div style="padding: 15px">
    <div class="row">
      <div class="configuratior-info-block blog-asside-right col-md-3">
        <div class="configuratior-info-content">
          <div class="panel panel-default sidebar-menu wow fadeInLeft animated" style="visibility: visible;">
            <div class="panel-heading">
              <h3 class="panel-title">{{ $t('labels.search') }}:</h3>
            </div>
            <div class="panel-body search-widget">
              <form action="" class=" form-inline">
                <fieldset>
                  <div class="row">
                    <div class="col-xs-12">
                      <select
                        id="lunchBegins"
                        class="selectpicker"
                        data-live-search="true"
                        data-live-search-style="begins"
                        :title="$t('labels.select_place')"
                        name="place"
                        v-model="selectedPlace">
                        <option value=""></option>
                        <option v-for="place,pIndex in selectablePlaces"
                          :key="pIndex"
                          :value="place">
                          {{ place }}
                        </option>
                      </select>
                    </div>
                  </div>
                </fieldset>
                <fieldset>
                  <div class="row">
                    <div class="col-xs-12">
                      <select
                        id="lunchBegins"
                        class="selectpicker"
                        data-live-search="true"
                        data-live-search-style="begins"
                        :title="$t('labels.select_exhibition')"
                        v-model="selectedExhibition">
                        <option value=""></option>
                        <option v-for="exhibition,eIndex in selectableExhibitions"
                          :key="eIndex"
                          :value="exhibition">
                          {{ exhibition }}
                        </option>
                      </select>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
        <ul class="list-unstyled language-block">
          <li>
            <a href="#" @click="selectLocale('de')" :class="{'active': !inEnglish}">
              <img class="flag" src="/images/de.svg" alt=""/>
            </a>
          </li>
          <li>
            <a href="#" @click="selectLocale('en')" :class="{'active': inEnglish}">
              <img class="flag" src="/images/gb.svg" alt=""/>
            </a>
          </li>
        </ul>
      </div>
      <div class="blog-lst col-md-9 p1" v-if="items.length > 0">
        <div class="col-md-12 clear" v-if="foundResults">
          <div id="list-type" class="proerty-th">
            <div v-for="item,iIndex in filteredItems"
              :key="iIndex"
              class="col-xs-offset-1 col-xs-10 col-sm-offset-0 col-sm-5 col-md-offset-0 col-md-4 p0">
              <exhibition-item :exhibition="item" ></exhibition-item>
            </div>
          </div>
        </div>
        <div class="col-md-12 clear" v-else>
          <p>{{ $t('labels.no_results') }}</p>
        </div>
      </div>
      <div class="blog-lst col-md-9 p1" v-else>
        <div class="col-md-12 clear">
          <p>{{ $t('labels.no_entries') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useMainStore } from '@/store'
import { computed, ref } from 'vue'
import axios from 'axios'

const store = useMainStore()
// define passed props
const props = defineProps({
  items: {
    type: Array,
    default: [],
  },
})
// define reactive props
const selectedPlace = ref('')
const selectedExhibition = ref('')
// define computed props
const locale = computed(() => store.settings.locale)

const inEnglish = computed(() => {
  return locale.value === 'en'
})

const filteredItems = computed(() => {
  return props.items.filter(item => {
    if (inEnglish.value) {
      return (item.place_en.toLowerCase().indexOf(selectedPlace.value.toLowerCase()) > -1
        && item.name_en.toLowerCase().indexOf(selectedExhibition.value.toLowerCase()) > -1)
    } else {
      return (item.place.toLowerCase().indexOf(selectedPlace.value.toLowerCase()) > -1
        && item.name.toLowerCase().indexOf(selectedExhibition.value.toLowerCase()) > -1)
    }
  })
})

const foundResults = computed(() => {
  return (filteredItems.value.length > 0)
})

const selectablePlaces = computed(() => {
  let places = []
  for (let i = 0; i < props.items.length; i++) {
    const place = (inEnglish.value)
      ? props.items[i].place_en
      : props.items[i].place
    if (places.indexOf(place) === -1) {
      places.push(place)
    }
  }
  return places
})

const selectableExhibitions = computed(() => {
  let exhibitions = []
  for (let i = 0; i < props.items.length; i++) {
    const exhibitionName = (inEnglish.value)
      ? props.items[i].name_en
      : props.items[i].name
    if (exhibitions.indexOf(exhibitionName) === -1) {
      exhibitions.push(exhibitionName)
    }
  }
  return exhibitions
})
// define methods
const selectLocale = (val) => {
  if (locale.value === val) {
    return
  }
  store.settings.locale = val

  axios.post('/locale', { language: val })
    .then(response => {
      if (response.data.successful) {
        $i18n.locale = val
      }
    })
    .catch(err => {
      console.error(err)
    })
    .finally(() => {
      window.location.reload()
    })
}
</script>